/* THANH NGHE GỌI (softphone) + HỘP THOẠI */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, DatePicker, Input, Modal, Select } from 'antd';
import dayjs from 'dayjs';
import { PhoneIncoming } from 'lucide-react';
import { CUS, FLAG_OPTS, TELE_LIST, TL_LOAI } from './Data';
import { useS } from './Store';
import { Note, Q, Q_RING, TXT_MUTED, cx, fmt } from './UI';

export const SoftBar: React.FC = () => {
  const S = useS();
  const { call, agent } = S;
  const dot = call ? '#2E75B6' : agent.st === 'Sẵn sàng' ? '#2E7D4F' : agent.st === 'Tạm nghỉ' ? '#C77700' : '#999';
  const cu = call ? CUS[call.ma] : null;
  return (
    <div className="fixed bottom-3 left-3 right-3 z-50 flex flex-wrap items-center gap-2 rounded-lg bg-[#16406b] px-3 py-2 text-sm text-white shadow-lg dark:bg-slate-800 sm:right-auto md:left-[80px]">
      <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ background: dot }} aria-hidden />
      <b>NV-03 · Telesales</b>
      {call ? (
        <span className="rounded bg-[#2E75B6] px-2 py-0.5">{call.phase === 'talk' ? 'Đang gọi' : 'Sau cuộc gọi'} (tổng đài tự đặt)</span>
      ) : (
        <Select
          size="small" style={{ width: 120 }} value={agent.st}
          onChange={(v) => S.setAgent({ st: v, rs: v === 'Tạm nghỉ' ? agent.rs : '' })}
          options={['Sẵn sàng', 'Tạm nghỉ', 'Ngoại tuyến'].map((x) => ({ value: x, label: x }))}
        />
      )}
      {!call && agent.st === 'Tạm nghỉ' && (
        <span className={cx('flex items-center gap-1 rounded bg-white/10 px-1.5 py-0.5', Q_RING)}>
          Lý do (bắt buộc — R16)
          <Select size="small" style={{ width: 150 }} placeholder="— chọn —" value={agent.rs || undefined} onChange={(v) => S.setAgent({ ...agent, rs: v })} options={['Nghỉ trưa', 'Họp', 'Đào tạo', 'Việc hành chính'].map((x) => ({ value: x, label: x }))} />
          <Q />
        </span>
      )}
      {call && cu ? (
        <>
          <button type="button" onClick={S.gotoCall} title="Về tab khách đang gọi" className="rounded bg-[#2E75B6] px-2 py-0.5 text-left">
            {call.phase === 'talk' ? (call.hold ? 'Đang giữ máy' : call.incoming ? 'Cuộc gọi đến' : 'Đang gọi') : 'Đã gác máy'} · {cu.ten} · {cu.ma} · <b>{fmt(call.sec)}</b>
          </button>
          {call.phase === 'talk' ? (
            <>
              <Button size="small" danger type="primary" onClick={S.hangup}>Gác máy</Button>
              <Button size="small" onClick={S.toggleHold}>{call.hold ? 'Tiếp tục' : 'Giữ máy'}</Button>
              <Button size="small" disabled>Chuyển cuộc <Q /></Button>
            </>
          ) : (
            <span className={cx('rounded px-2 py-0.5', call.acw < 0 ? 'bg-[#B03A2E]' : 'bg-[#C77700]')}>
              {call.acw >= 0 ? <>Hoàn tất sau cuộc gọi: còn {fmt(call.acw)} <Q>giới hạn</Q></> : `Quá giới hạn hoàn tất: +${fmt(call.acw)} (R15)`}
            </span>
          )}
        </>
      ) : (
        <>
          <span className="text-[#BFD9E4]">Không có cuộc gọi</span>
          <Button size="small" icon={<PhoneIncoming size={13} />} onClick={() => S.startCall('KH-20418', true)}>Mô phỏng gọi đến</Button>
          <Button size="small" onClick={() => toast.info('Mở bàn phím gọi số mới (minh hoạ)')}>Gọi số mới</Button>
        </>
      )}
    </div>
  );
};

const FieldRow: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div className="grid grid-cols-[90px_1fr] items-start gap-2">
    <span className={cx('pt-1', TXT_MUTED)}>{label}</span>
    <div>{children}</div>
  </div>
);

export const TaskModal: React.FC<{ ma?: string }> = ({ ma }) => {
  const S = useS();
  const [m, setM] = useState(ma ?? TELE_LIST[0]);
  const [lo, setLo] = useState(TL_LOAI[0]);
  const [han, setHan] = useState(dayjs().add(1, 'day').hour(9).minute(0).second(0));
  const [nv, setNv] = useState('NV-03');
  const [gc, setGc] = useState('');
  return (
    <Modal open title="+ Tạo việc (hàng đợi Telesales)" okText="Tạo việc" cancelText="Huỷ" onCancel={() => S.setModal(null)} onOk={() => S.submitTask({ ma: m, loai: lo, han: han.format('DD/MM HH:mm'), nv })}>
      <div className="space-y-2.5 text-[12.5px]">
        <FieldRow label="Khách"><Select className="!w-full" value={m} onChange={setM} options={TELE_LIST.map((x) => ({ value: x, label: `${x} · ${CUS[x].ten}` }))} /></FieldRow>
        <FieldRow label="Loại việc"><Select className="!w-full" value={lo} onChange={setLo} options={TL_LOAI.map((x) => ({ value: x, label: x }))} /></FieldRow>
        <FieldRow label="Hạn"><DatePicker showTime format="DD/MM/YYYY HH:mm" value={han} allowClear={false} onChange={(d) => d && setHan(d)} /></FieldRow>
        <FieldRow label="Người nhận"><Select className="!w-full" value={nv} onChange={setNv} options={['NV-03', 'NV-01', 'NV-02', 'NV-04'].map((x) => ({ value: x, label: x }))} /></FieldRow>
        <FieldRow label="Ghi chú"><Input.TextArea rows={2} value={gc} onChange={(e) => setGc(e.target.value)} placeholder="Không ghi chi tiết bệnh lý" /></FieldRow>
        <Note>Việc tạo tay ghi nguồn “Tạo tay · người tạo” và một dòng Lịch sử chạm.</Note>
      </div>
    </Modal>
  );
};

export const FlagModal: React.FC<{ ma: string }> = ({ ma }) => {
  const S = useS();
  const [flag, setFlag] = useState(FLAG_OPTS[0]);
  const [ly, setLy] = useState('');
  return (
    <Modal open title={`Gắn cờ · ${ma}`} okText="Gắn cờ" cancelText="Huỷ" onCancel={() => S.setModal(null)} onOk={() => S.submitFlag({ ma, flag })}>
      <div className="space-y-2.5 text-[12.5px]">
        <FieldRow label="Cờ"><Select className="!w-full" value={flag} onChange={setFlag} options={FLAG_OPTS.map((x) => ({ value: x, label: x }))} /></FieldRow>
        <FieldRow label="Lý do"><Input.TextArea rows={2} value={ly} onChange={(e) => setLy(e.target.value)} /></FieldRow>
        <Note>Cờ chạy song song với trạng thái, không đổi mã S / CS (R37). Gắn / gỡ cờ ghi nhật ký. Danh sách cờ <Q /></Note>
      </div>
    </Modal>
  );
};